import classNames from 'classnames';
import React from 'react';
import { Link } from 'wouter';

import { addNonBreakingSpaces } from '../../lib/utils';

import styles from '../../../styles/partials/page-title.module.css';

interface PageTitleProps {
    title: string;
    icon?: React.ReactNode;
    href?: string | null;
    isPageHeading?: boolean;
    className?: string | null;
    textClassName?: string | null;
}

function PageTitle({
    title = null,
    icon = null,
    href = null,
    isPageHeading = true,
    className = null,
    textClassName = null,
}: PageTitleProps) {
    const innerElements = (
        <>
            {icon}
            <span
                className={classNames([
                    styles.text,
                    {
                        [textClassName]: textClassName !== null,
                    },
                ])}
            >
                {title !== null ? addNonBreakingSpaces(title) : null}
            </span>
        </>
    );

    const Tag = isPageHeading ? 'h1' : 'strong';

    return (
        <Tag
            className={classNames({
                [styles.container]: true,
                [className]: className !== null,
            })}
        >
            {href !== null ? (
                <Link href={href} className={styles.link}>
                    {innerElements}
                </Link>
            ) : (
                innerElements
            )}
        </Tag>
    );
}

export default PageTitle;
